/** InsCoder WANG.J 2026-08-20 B + Product media tab switcher logic (tab switching, carousel visibility & counter sync) **/

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__media-tabs-nav').forEach((nav) => {
    new ProductMediaTabs(nav);
  });
});

class ProductMediaTabs {
  constructor(nav) {
    this.nav = nav;
    this.wrapper = nav.closest('.product__media-tabs-card');
    this.tabs = Array.from(nav.querySelectorAll('[data-media-tab-index]'));
    this.carousels = Array.from(this.wrapper.querySelectorAll('flickity-carousel[data-media-tab]'));
    this.counters = Array.from(this.wrapper.querySelectorAll('.cust-media-counter'));

    this._bindEvents();
    this._updateCounter('0');
  }

  _bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this._activate(tab));
    });

    /* Play/pause is handled by the play button ONLY. Bind directly on the button so the
       click / drag never reaches flickity's viewport (click-nav static click / drag start). */
    this.wrapper.querySelectorAll('.cust-media-tab-video__play').forEach((playButton) => {
      playButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this._onVideoButtonClick(playButton);
      });
      playButton.addEventListener('pointerdown', (event) => {
        event.stopPropagation();
      });
    });

    /* While a video is playing the whole cell is locked: tapping anywhere else pauses it */
    this.wrapper.addEventListener('click', (event) => {
      const playingCell = event.target.closest('.cust-media-tab-item.is-video-playing');
      if (playingCell) {
        event.stopPropagation();
        const video = playingCell.querySelector('.cust-media-tab-video video');
        if (video) {
          video.pause();
        }
      }
    });

    this.carousels.forEach((carousel) => {
      const tabIndex = carousel.getAttribute('data-media-tab');
      carousel.addEventListener('flickity:ready', () => this._updateCounter(tabIndex));
      carousel.addEventListener('flickity:slide-changed', () => {
        this._updateCounter(tabIndex);
        this._pauseVideosIn(carousel);
      });
      carousel.addEventListener('flickity:slide-settled', () => this._updateCounter(tabIndex));
    });
  }

  _pauseVideosIn(carousel) {
    carousel.querySelectorAll('.cust-media-tab-video video').forEach((video) => video.pause());
  }

  _onVideoButtonClick(playButton) {
    const container = playButton.closest('.cust-media-tab-video');
    const poster = container.querySelector('.cust-media-tab-video__poster');
    const player = container.querySelector('.cust-media-tab-video__player');
    const video = player.querySelector('video');

    if (!video) {
      return;
    }

    /* Keep the play button / caption / carousel lock in sync with the actual playback state */
    if (!video.dataset.controlsBound) {
      video.dataset.controlsBound = 'true';
      const caption = container.parentElement.querySelector('.cust-media-tab-caption');
      const cell = container.closest('.cust-media-tab-item');
      const carousel = container.closest('flickity-carousel[data-media-tab]');

      video.addEventListener('play', () => {
        playButton.classList.add('is-playing');
        if (caption) {
          caption.classList.add('is-hidden');
        }
        /* Lock the carousel while playing: no swipe, and click-nav is skipped for video cells */
        if (cell) {
          cell.classList.add('is-video-playing');
          cell.setAttribute('data-media-type', 'video');
        }
        if (carousel) {
          carousel.setDraggable(false);
        }
      });

      video.addEventListener('pause', () => {
        playButton.classList.remove('is-playing');
        if (caption) {
          caption.classList.remove('is-hidden');
        }
        if (cell) {
          cell.classList.remove('is-video-playing');
          cell.removeAttribute('data-media-type');
        }
        if (carousel) {
          carousel.setDraggable(true);
        }
      });
    }

    if (!poster.hidden) {
      /* First interaction from the poster: swap to the player */
      poster.hidden = true;
      player.hidden = false;
    }

    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }

  _activate(tab) {
    const index = tab.getAttribute('data-media-tab-index');

    /* Pause any playing videos before switching away */
    this.wrapper.querySelectorAll('.cust-media-tab-video video, native-video, external-video').forEach((video) => video.pause());

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.carousels.forEach((carousel) => {
      if (carousel.getAttribute('data-media-tab') === index) {
        carousel.removeAttribute('hidden');
        this._ensureSized(carousel);
      } else {
        carousel.setAttribute('hidden', '');
      }
    });

    this.counters.forEach((counter) => {
      counter.hidden = counter.getAttribute('data-media-counter') !== index;
    });

    this._syncZoomButton(index);

    this._updateCounter(index);
  }

  async _ensureSized(carousel) {
    try {
      const instance = await carousel.flickityInstance;
      requestAnimationFrame(() => instance.resize());
    } catch (error) {
      /* Flickity may not be ready yet; counter is refreshed on "flickity:ready" */
    }
  }

  async _updateCounter(index) {
    const counter = this.counters.find((item) => item.getAttribute('data-media-counter') === String(index));
    const carousel = this.carousels.find((item) => item.getAttribute('data-media-tab') === String(index));

    if (!counter || !carousel) {
      return;
    }

    const currentElement = counter.querySelector('.cust-media-counter-current');
    const totalElement = counter.querySelector('.cust-media-counter-total');

    if (!currentElement || !totalElement) {
      return;
    }

    try {
      const instance = await carousel.flickityInstance;

      if (instance && instance.cells) {
        currentElement.textContent = String((instance.selectedIndex + 1) || 1);
        totalElement.textContent = String(instance.cells.length);
      }
    } catch (error) {
      /* Carousel is still hidden; fall back to static values */
    }
  }

  async _syncZoomButton(index) {
    const zoomButton = this.wrapper.closest('.product__media-list-wrapper') && this.wrapper.closest('.product__media-list-wrapper').querySelector('.product__zoom-button');

    if (!zoomButton) {
      return;
    }

    if (index !== '0') {
      zoomButton.hidden = true;
      return;
    }

    const mainCarousel = this.carousels.find((item) => item.getAttribute('data-media-tab') === '0');

    try {
      const instance = await mainCarousel.flickityInstance;
      zoomButton.hidden = instance.selectedElement.getAttribute('data-media-type') !== 'image';
    } catch (error) {
      zoomButton.hidden = false;
    }
  }
}

/** InsCoder WANG.J 2026-08-20 E + Product media tab switcher logic **/
